import {useTranslation} from 'react-i18next';

import {Divider, Grid, Typography} from '@mui/material';

import {containerStyles, dividerStyles} from './BoardViewStyles';

export const BoardViewEmptyState = () => {
  const {t} = useTranslation('translation', {keyPrefix: 'companyApplicants.applicantsCard.headers'});

  return (
    <Grid
      container
      spacing={2}
      sx={containerStyles}
    >
      <Grid item width={'370px'}>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            <Typography variant='h4' mb={4}>
              {t('new')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Divider
        orientation='vertical'
        flexItem
        sx={{display: {xs: 'none', md: 'block'}, ...dividerStyles}}
      />

      <Grid item width={'370px'}>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            <Typography variant='h4' mb={4}>
              {t('contacted')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Divider
        orientation='vertical'
        flexItem
        sx={{display: {xs: 'none', sm: 'none', md: 'none', lg: 'block'}, ...dividerStyles}}
      />

      <Grid item width={'370px'}>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            <Typography variant='h4' mb={4}>
              {t('interview')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
